<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    :modal-append-to-body="true"
    :modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="80px">
    <el-form-item label="审批人" prop="applyName">
      <el-autocomplete class="inline-input" v-model="dataForm.applyName" :fetch-suggestions="peopleSearch"
        @select="peopleSelect">
        <template slot-scope="scope">
          <p>{{scope.item.userName}}</p>
        </template>
      </el-autocomplete>
    </el-form-item>
    <el-form-item label="审批消息接收" prop="tipInfo">
      <el-radio-group v-model="dataForm.tipInfo">
        <el-radio :label="0">公众号</el-radio>
        <el-radio :label="1">邮箱</el-radio>
        <el-radio :label="2">短信</el-radio>
      </el-radio-group>
    </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import Api from '../../../components/Api/index'
  export default {
    data () {
      return {
        checkPeople: '',
        visible: false,
        dataForm: {
          id: 0,
          tipInfo: 0,
          configId: -1,
          applyId: '',
          applyName: '',
          applyCompanyId: '',
          applyCompanyName: '',
          step: ''
        },
        dataRule: {
          tipInfo: [
            { required: true, message: '请选择消息接收方式', trigger: 'blur' }
          ],
          applyName: [
            { required: true, message: '请选择审批人', trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      peopleSearch(queryString, cb){
        new Api('user').getUserList({page: 1, size: 10, q: {
          userName: queryString
        }}).then(res => {
          if (res.status == 200) {
            cb(res.data.records)
          }
        })
      },
      peopleSelect(item){
        this.dataForm.applyName = item.userName
        this.dataForm.applyCompanyId = item.mechanismId
        this.dataForm.applyCompanyName = item.mechanismName
        this.dataForm.applyId = item.id
        this.$refs.dataForm.validateField('applyName', (err) => { })
      },
      init (id,configId,step) {
        this.dataForm.id = id || 0
        this.visible = true
        this.dataForm.configId = configId
        this.dataForm.step = step
        this.$nextTick(() => {
          this.$refs['dataForm'].resetFields()
          if (this.dataForm.id) {
            new Api("apply").hierarchyInfo(this.dataForm.id).then((data) => {
              if (data && data.status === 200) {
                this.dataForm.tipInfo = data.data.tipInfo
                this.dataForm.applyName = data.data.applyName
              }
            })
          }
        })
      },
      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            new Api("apply").hierarchyUpdateOrSave(
              {
                'id': this.dataForm.id || undefined,
                'tipInfo': this.dataForm.tipInfo,
                'configId': this.dataForm.configId,
                'applyId': this.dataForm.applyId,
                'applyName': this.dataForm.applyName,
                'applyCompanyId': this.dataForm.applyCompanyId,
                'applyCompanyName': this.dataForm.applyCompanyName,
                'step': this.dataForm.step
              }
            ).then((data) => {
              if (data && data.status === 200) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 100,
                  onClose: () => {
                    this.visible = false
                    this.$emit('refreshDataList')
                  }
                })
              } else {
                this.$message.error(data.message)
              }
            })
          }
        })
      }
    }
  }
</script>
<style scoped lang="scss">
 /deep/ .el-form-item__label {
  width: 110px !important;
 }
 /deep/ .el-input {
  width: 90%;
 }
</style>
